/**
 * Simple utility functions for handling image loading
 */

// Get image URL based on whether we should use cached or uncached version
export const getImageUrl = (scientificName, apiEndpoints, useCached = true) => {
  if (!scientificName || !apiEndpoints) return null;
  
  var endpoint;

  if (useCached && apiEndpoints.images_scientific_name) {
    endpoint = apiEndpoints.images_scientific_name;
  } else if (apiEndpoints.images_uncached_scientific_name) {
    endpoint = apiEndpoints.images_uncached_scientific_name;
  }

  if (endpoint) {
    return endpoint.replace("<scientific_name>", scientificName);
  }
  
  return null;
};

// Get the appropriate image source based on current load status
export const getAppropriateImageSrc = (scientificName, apiEndpoints, cachedImageFailed) => {
  const shouldUseCached = !cachedImageFailed[scientificName];
  return getImageUrl(scientificName, apiEndpoints, shouldUseCached);
};

export const fallbackToApiMedia = (event) => {
  const image = event.currentTarget || event.target;
  const apiBase = window._env_?.REACT_APP_BACKEND_URL;
  if (!image?.src || !apiBase) return false;
  try {
    const current = new URL(image.src);
    if (!/^\/generated-(?:species|product)-images\//.test(current.pathname)) return false;
    const fallback = new URL(`${current.pathname}${current.search}`, apiBase);
    if (current.href === fallback.href) return false;
    image.src = fallback.href;
    return true;
  } catch {
    return false;
  }
};

// Create props for an image element with appropriate handlers
export const createImageProps = (
  scientificName,
  apiEndpoints,
  cachedImageFailed,
  markCachedImageFailed,
  markImageLoaded,
  additionalProps = {}
) => {
  return {
    src: getAppropriateImageSrc(scientificName, apiEndpoints, cachedImageFailed),
    loading: "lazy",
    onLoad: () => {
      // Mark this image as successfully loaded in the central state
      markImageLoaded(scientificName);
    },
    onError: (e) => {
      if (!cachedImageFailed[scientificName]) {
        // If cached image failed, mark it and try uncached
        markCachedImageFailed(scientificName);
        
        // Immediately set the source to the uncached URL
        const uncachedUrl = getImageUrl(scientificName, apiEndpoints, false);
        if (uncachedUrl && e.target) {
          e.target.src = uncachedUrl;
        }
      }
    },
    ...additionalProps
  };
};
